import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const Sound = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 24' {...rest}>
    {type === 'stroke' ? (
      <path
        d='m8.99 15.688 1.093.565V7.03c0-.492.313-.906.739-1.037l7.11-2.198a1 1 0 0 1 .795.097l-.726.224-7.111 2.198-.529.163v11.318c0 1.393-1.292 2.455-2.805 2.455S4.75 19.188 4.75 17.795s1.293-2.455 2.806-2.455c.5 0 .999.124 1.433.348m9.982-10.855V4.09c.17.188.278.443.278.742v10.215c0 1.393-1.293 2.455-2.806 2.455s-2.805-1.062-2.805-2.455 1.292-2.455 2.805-2.455c.502 0 1 .124 1.434.348l1.094.565z'
        stroke='currentColor'
        strokeWidth='1.5'
      />
    ) : (
      <path
        d='M20 4.833c0-1.227-1.148-2.107-2.289-1.755l-7.11 2.198c-.753.232-1.268.945-1.268 1.754v7.992a3.9 3.9 0 0 0-1.777-.432C5.75 14.59 4 15.876 4 17.795S5.75 21 7.556 21c1.805 0 3.555-1.286 3.555-3.205V7.03l7.111-2.197v7.442a3.9 3.9 0 0 0-1.778-.432c-1.805 0-3.555 1.286-3.555 3.205s1.75 3.205 3.555 3.205S20 16.967 20 15.048z'
        fill='currentColor'
      />
    )}
  </IconBase>
);
